import { IDictionary, MLHelper } from '@bimser/core';
import IconLanguage from '@bimser/icons/16/language';
import { Button } from 'devextreme-react/button';
import { DropDownBox, DropDownBoxRef, DropDownOptions } from 'devextreme-react/drop-down-box';
import { DropDownButtonTypes } from 'devextreme-react/drop-down-button';
import {
	TextBox,
	Button as TextBoxButton,
	Options as TextBoxOptions
} from 'devextreme-react/text-box';
import React from 'react';
import { findMessage } from '../..';

const saveButtonStyles = { margin: '10px 0 0 0', float: 'right' };

export const MLTextBox = React.memo<any>(function MLTextBox(props) {
	const dropDownBoxRef = React.useRef<DropDownBoxRef>();

	const onValueChanged: OnMLValueChanged = (newData, closeDropdown) => {
		props.data.setValue({
			...props.data.value,
			...newData
		});
		if (closeDropdown) {
			dropDownBoxRef.current.instance().close();
		}
	};

	const renderCurrentLanguage = () => (
		<TextBox
			defaultValue={props.data.value?.[MLHelper.currentLanguage.culture]}
			onValueChange={e => onValueChanged({ [MLHelper.currentLanguage.culture]: e })}
		>
			<TextBoxButton
				location="after"
				name="multiLanguage"
			>
				<TextBoxOptions
					icon={IconLanguage.info.getElement()}
					stylingMode="contained"
					onClick={onClickMultiLanguage}
				/>
			</TextBoxButton>
		</TextBox>
	);

	const onClickMultiLanguage = (e: DropDownButtonTypes.ButtonClickEvent) => {
		e.event.preventDefault();
		e.event.stopPropagation();
		e.event.stopImmediatePropagation();

		dropDownBoxRef.current.instance().open();
	};

	const renderSupportedLanguages = () => (
		<OtherLanguagesEditor
			defaultValue={props.data.value}
			onValueChanged={onValueChanged}
		/>
	);

	return (
		<DropDownBox
			ref={dropDownBoxRef}
			openOnFieldClick={false}
			showDropDownButton={false}
			fieldRender={renderCurrentLanguage}
			contentRender={renderSupportedLanguages}
		>
			<DropDownOptions
				minWidth={200}
				hideOnOutsideClick
				hideOnParentScroll
				container={props.data.column.editorOptions?.getDropdownContainer?.()}
			/>
		</DropDownBox>
	);
});

const OtherLanguagesEditor: React.FC<{
	defaultValue: IDictionary<string>;
	onValueChanged: OnMLValueChanged;
}> = props => {
	const value = React.useRef(props.defaultValue || {});

	return (
		<>
			{MLHelper.supportedLanguages.map(supportedLanguage => {
				if (supportedLanguage.id !== MLHelper.currentLanguage.id) {
					return (
						<TextBox
							key={supportedLanguage.id}
							labelMode="static"
							label={supportedLanguage.name}
							defaultValue={props.defaultValue?.[supportedLanguage.culture]}
							onValueChange={e => {
								value.current = {
									...value.current,
									[supportedLanguage.culture]: e
								};
							}}
						/>
					);
				}
			})}
			<Button
				text={findMessage.get('100620')}
				type="default"
				stylingMode="contained"
				style={saveButtonStyles}
				onClick={() => {
					props.onValueChanged(value.current, true);
				}}
			/>
		</>
	);
};

type OnMLValueChanged = (newData: IDictionary<string>, closeDropdown?: boolean) => void;
